export default "__VITE_ASSET__wD2CP6H6__"